<template>
	<span class="text-nowrap">
		<span class="sr-only">€</span>
		<span v-if="isNaN(Number(value))">
			{{ value }}
		</span>
		<span v-else>
			{{ numberFormatter(value as number) }}
		</span>
	</span>
</template>

<script setup lang="ts">
import { numberFormatter } from '#base/helpers/urlHelpers';

defineProps<{
	value: number | string;
}>();
</script>
